import React, { PureComponent } from 'react'
import { isString } from 'lodash'
import PropTypes from 'prop-types'

export default class InputSelectField extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    fieldName: PropTypes.string.isRequired,
    fieldValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    setupValue: PropTypes.string,
    previousStatus: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    emptyOption: PropTypes.bool,
    emptyOptionText: PropTypes.string,
    readOnly: PropTypes.bool
  }

  render() {
    return (
      <div className="group">
        <div className="input-wrapper">
          {this.props.title !== undefined ? (
            <label className={`header ${this.props.error ? 'error' : ''}`} htmlFor={this.props.fieldName}>
              {this.props.title}
            </label>
          ) : null}

          <select
            id={this.props.fieldName}
            className={`input-field select-field ${this.props.error ? 'error' : ''}`}
            value={this.props.fieldValue || ''}
            onChange={this.handleChange}
            disabled={this.props.readOnly}
          >
            {this.props.emptyOption ? (
              <option value="">{this.props.emptyOptionText ? this.props.emptyOptionText : ''}</option>
            ) : null}

            {this.props.options.map(option => {
              // option expected to be object containing displayText and value props
              // for backwards compatibility, can also be a string
              const optionStringToDisplay = typeof option === 'object' ? option.displayText : option.replace(/_/g, ' ')

              // TODO: I don't understand the following code. Is it correct? Do we (still) need this? Can we simplify it?
              if (
                option !== this.props.fieldValue &&
                this.props.setupValue &&
                this.props.setupValue === this.props.fieldValue &&
                !this.props.previousStatus
              ) {
                return (
                  <option disabled key={option} value={option}>
                    {optionStringToDisplay}
                  </option>
                )
              }

              return (
                // {option.value || option} doesn't work here, as option.value could be '' or null
                <option
                  key={option.value !== undefined ? option.value : option}
                  value={option.value !== undefined ? option.value : option}
                >
                  {optionStringToDisplay}
                </option>
              )
            })}
          </select>
          {this.props.error && isString(this.props.error) && (
            <div className="input-error-message">{this.props.error}</div>
          )}
        </div>
      </div>
    )
  }

  handleChange = event => {
    this.props.onChange(event.target.value, this.props.fieldName)
  }
}
